import { useEffect, DependencyList } from 'react';

function useAsyncEffect<T>(effect: () => Promise<T>, deps?: DependencyList, cleanup?: () => void) {
  useEffect(() => {
    effect().catch(console.error);
    // TODO add AbortController on cleanup
    return cleanup;
  }, deps);
}

export default useAsyncEffect;
